<template>
  <main>
    <!-- Partner Section -->
    <section class="section-item">
      <div class="section-col-2">
        <img
          src="https://api.slater.co.nz/v/add57ce6-411d-4377-99e4-0b10b7301381.jpg"
          alt="Dinu Harry"
          class="partner-image"
        />
      </div>

      <div class="section-col-1">
        <div class="partner-name">Dinu Harry</div>
        <div class="partner-title">
          2010 President of the New Zealand Institute of Chartered Accountants. (now CAANZ)
        </div>
        <div class="partner-bio">
          An Accountant with extensive governance, business, accounting and financial management
          experience in the public, private and not for profit sectors.
        </div>
        <div class="partner-bio">
          Governance experience includes Chairing Audit, Finance and Risk Committees and overseeing
          extensive business transformation projects
        </div>
        <div class="partner-bio">
          Extensive networks within the New Zealand Indian and other Ethnic communities,
          particularly in Auckland
        </div>
        <div class="partner-bio">
          This experience has been gained through my involvement as an accountant and business
          advisor to a range of clients and through election and/or appointment to a range of
          entities in a leadership/governance role in the public, private and not for profit
          sectors.
        </div>

        <div class="section-contact">
          <a href="tel:078389701" class="contact-item">07 838 9701</a>
          <a href="mailto:dinu@slater.co.nz" class="contact-item">dinu@slater.co.nz</a>
          <a
            href="https://nz.linkedin.com/in/dinu-harry-00970231"
            target="_blank"
            class="contact-item"
            >Linkedin</a
          >
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="cta-title">Experience the Slater difference</div>
      <div class="cta-subtitle">Too busy to come to us? we can come to you!</div>
      <a href="/contact" class="cta-button"> Lets talk </a>
    </section>
  </main>
</template>

<script setup>
document.title = 'Partners - Slater';
</script>

<style scoped>
.section-item {
  margin-top: 200px;
  display: flex;
}

.section-col-1 {
  width: 30vw;
  margin-left: 2vw;
  display: flex;
  flex-direction: column;
}

.section-col-2 {
  width: 30vw;
  margin-left: 10vw;
  display: flex;
  align-items: center;
}

.partner-image {
  width: 300px;
  height: auto;
  object-fit: cover;
  border-radius: 50%;
}

.partner-name {
  font-size: 38px;
  font-weight: 600;
  color: #213b55;
  margin-bottom: 25px;
}

.partner-title,
.partner-bio {
  color: #213b55;
  margin-bottom: 30px;
  font-size: 21px;
}

.section-contact {
  display: flex;
  margin-top: 20px;
}

.contact-item {
  margin-right: 20px;
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration-color: #13b5ea;
  font-weight: 600;
  font-size: 21px;
}

.cta-section {
  margin: 200px 2vw;
  display: flex;
  flex-direction: column;
  background-color: #6fefc1;
  justify-content: center;
  align-items: center;
}

.cta-title {
  font-size: 51px;
  font-weight: 600;
  color: #213b55;
  margin-top: 50px;
  text-align: center;
  padding: 10px;
}

.cta-subtitle {
  font-size: 27px;
  color: #213b55;
  margin-top: 10px;
}

.cta-button {
  font-weight: 500;
  cursor: pointer;
  margin: 50px 0;
  background-color: #213b55;
  color: #fff;
  padding: 5px 20px;
  max-width: 200px;
  font-size: 20px;
  border-radius: 4px;
  text-align: center;
  display: inline-block;
}

@media only screen and (max-width: 768px) {
  .section-item {
    flex-direction: column;
    margin-top: 100px;
  }

  .section-col-1,
  .section-col-2 {
    width: 100%;
    padding: 20px;
    margin-left: 0;
  }

  .section-col-2 {
    margin-bottom: 50px;
    justify-content: center;
  }

  .section-contact {
    flex-direction: column;
  }

  .contact-item {
    margin-left: 0;
    margin-bottom: 10px;
  }
}

@media only screen and (max-width: 480px) {
  .section-item {
    flex-direction: column;
    margin-top: 100px;
  }

  .section-col-1,
  .section-col-2 {
    width: 100%;
    padding: 20px;
    margin-left: 0;
  }

  .section-col-2 {
    margin-bottom: 50px;
    justify-content: center;
  }

  .section-contact {
    flex-direction: column;
  }

  .contact-item {
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>
